import { CheckCircle2, ArrowRight } from "lucide-react";
import { Section, Overline, PrimaryButton, QuoteBanner, Card } from "../components/Shared";
import { SOLUTIONS } from "../lib/data";
import { Seo } from "../components/Seo";
import { audienceSchema } from "../lib/seo";

const SCHEMA = [audienceSchema()];
const CRUMBS = [["Solutions", "/solutions"]];

export default function Solutions() {
  return (
    <>
      <Seo page="solutions" jsonLd={SCHEMA} breadcrumbs={CRUMBS} />
      <Section className="pt-36">
        <div className="max-w-3xl">
          <Overline>Solutions by Industry</Overline>
          <h1 className="mt-5 text-4xl sm:text-5xl font-extrabold text-slate-900 tracking-tight leading-[1.1]">
            The right data for the decisions you make
          </h1>
          <p className="mt-6 text-lg sm:text-xl text-slate-700 leading-relaxed">
            Whether you manage a public reservoir, a community lake, an HOA amenity, or a private pond, our
            surveys turn your waterbody into clear, actionable information.
          </p>
        </div>
      </Section>

      <Section className="pt-0 grid grid-cols-1 lg:grid-cols-2 gap-8">
        {SOLUTIONS.map((s) => (
          <Card key={s.slug} testId={`solution-card-${s.slug}`} className="p-8 sm:p-10">
            <div className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-cyan-700">{s.audience}</div>
            <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mt-2">{s.title}</h2>
            <p className="text-base text-slate-500 mt-3">What we help you solve:</p>
            <ul className="mt-4 space-y-3">
              {s.pains.map((p) => (
                <li key={p} className="flex items-start gap-3 text-slate-700">
                  <CheckCircle2 className="w-5 h-5 text-cyan-600 mt-1 shrink-0" />
                  {p}
                </li>
              ))}
            </ul>
            <PrimaryButton
              to="/request-a-quote"
              testId={`solution-quote-${s.slug}`}
              className="mt-8 !py-3 !px-5 text-base"
            >
              Request a Quote <ArrowRight className="w-4 h-4" />
            </PrimaryButton>
          </Card>
        ))}
      </Section>

      <QuoteBanner />
    </>
  );
}
